import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

export const buildPostFinalInterruptedEvent = ({
	conversationId,
	messageId,
	traceId,
	error,
	failureMode,
	reconnectAttempts,
	attributes,
	recoveryOutcome = 'completedAnswerPreserved',
	invalidatingEventType,
}: {
	conversationId: string;
	messageId: string | undefined;
	traceId: string | undefined;
	error: unknown;
	failureMode?: 'reconnectUnsupported' | 'budgetExhausted' | 'acquireFailed';
	reconnectAttempts: number;
	recoveryOutcome?: 'completedAnswerPreserved' | 'completionInvalidated';
	invalidatingEventType?: string;
	attributes?: Record<string, unknown>;
}): AnalyticsEventPayload => ({
	eventType: 'operational',
	action: 'interrupted',
	actionSubject: 'rovoChatStream',
	attributes: {
		...attributes,
		isDeepResearch: attributes?.isDeepResearch ?? null,
		thinkDeeperEnabled: attributes?.thinkDeeperEnabled ?? null,
		fastModeEnabled: attributes?.fastModeEnabled ?? null,
		conversationId,
		messageId,
		traceId,
		phase: 'afterFinalResponse',
		recoveryOutcome,
		...(invalidatingEventType ? { invalidatingEventType } : {}),
		failureMode,
		reconnectAttempts,
		errorName: error instanceof Error ? error.name : 'Unknown',
	},
});
